import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const MarketplaceData = ({
  producer_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/producers/${producer_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(Object.fromEntries(err));
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Konfiguracje pod marketplace", icon: "info" }}
      footer={
        <Button
          type="save"
          text={is_updating ? "Proszę czekać..." : "Zapisz"}
          disabled={pristine || invalid || is_updating}
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field
          name="allegro_responsible_producer_name"
          label="Allegro - nazwa producenta z marketplace"
          component={InputField}
          type="text"
        />
        <Field
          name="erli_responsible_producer_name"
          label="Erli - nazwa producenta z marketplace"
          component={InputField}
          type="text"
        />
        <Field
          name="amazon_gpsr_manufacturer_email"
          label="Amazon - GPRS manufacturer email"
          component={InputField}
          type="text"
        />
      </form>
    </Dashboard>
  );
};

export default reduxForm({
  form: "update-producer-marketplace-data",
  enableReinitialize: true,
})(MarketplaceData);
